<template>
  <div class="bank">
    <h1>
      bank
    </h1>
  </div>
</template>

<script>
export default {
  name: 'bank'
}
</script>

<style>

</style>